export default __webpack_public_path__ + "static/soehne-mono-web-leicht-a9e7423cd16bd4ca5769eaf999ae5653.eot";